/**
 * Domain redirect utility for authentication pages
 * Redirects users from bravenet.ca and bravenet.net to bravenet.com
 * for login/register/signup pages, with exceptions for localhost and bravenet.local
 */

/**
 * Check if the current domain should redirect to bravenet.com
 * @returns {boolean} True if redirect should happen
 */
export function shouldRedirectToBravenetCom() {
  const hostname = window.location.hostname.toLowerCase();
  
  // Don't redirect for localhost or bravenet.local (with or without port)
  if (hostname === 'localhost' || hostname === 'bravenet.local') {
    return false;
  }
  
  // Don't redirect if already on bravenet.com
  if (hostname === 'bravenet.com' || hostname === 'www.bravenet.com') {
    return false;
  }
  
  // Redirect for bravenet.ca and bravenet.net
  if (hostname === 'bravenet.ca' || hostname === 'www.bravenet.ca' ||
      hostname === 'bravenet.net' || hostname === 'www.bravenet.net') {
    return true;
  }
  
  return false;
}

/**
 * Check if the current route is an authentication page
 * @param {string} path - The current route path
 * @returns {boolean} True if it's an auth page
 */
export function isAuthPage(path) {
  const authPaths = ['/login', '/register', '/lostpassword'];
  return authPaths.includes(path);
}

/**
 * Perform the redirect to bravenet.com
 * @param {string} path - The current path to preserve
 * @param {string} search - The current search query to preserve
 */
export function redirectToBravenetCom(path, search) {
  const targetUrl = `https://www.bravenet.com${path}${search}`;
  window.location.href = targetUrl;
}

/**
 * Main function to check and perform domain redirect if needed
 * @param {string} path - The current route path
 * @param {string} search - The current search query
 * @returns {boolean} True if redirect was performed
 */
export function checkAndRedirect(path, search = '') {
  if (shouldRedirectToBravenetCom() && isAuthPage(path)) {
    redirectToBravenetCom(path, search);
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./apps/www.bravenet.com/src/utils/domain-redirect.js